// extracted by mini-css-extract-plugin
module.exports = {"container":"_1a-74QMnwWuuQK-l4jNI8c","heading":"_3zoLd-I_UG9OqrnaGfCN9V","requiredLabel":"_9EpqoHjphdAW6rXyHP2wl","items":"_1CBBswqXr5_ccjhXQuSzNm"};